import { Component } from '@opten/gin-tonic/helpers/compiler';

@Component({ className: 'js-share' })
export class ShareComponent {
    constructor(private element: HTMLElement) {
        const shareData = {
            title: element.dataset?.title || undefined,
            text: element.dataset?.text || undefined,
            url: element.dataset?.url || undefined
        };
                  
        element.addEventListener("click", async (e) => {
            e.preventDefault();
            try {
                await navigator.share(shareData);
            } catch (err) {
                console.error("Error sharing the URL!");
            }
        });
    }
}
